import { CoreType } from "../../Core/Core.Interfaces";
import { GenericTableSchemaInterface } from "../../Table/Table.Interfaces";
import { VarKey } from "../../Variables/Generated/VarKey.Data";

export const FMSPlusPaymentMethodExpiring00Table: GenericTableSchemaInterface = {
  id: "fms-plus-payment-method-expiring-00",
  name: "FMS+ Payment Method Expiring 00",
  description:
    "This table contains data regarding how many people were sent emails and texts messages via our FMS+ Payment Method Expiring workflows.",
  core: CoreType.STORAGE,
  // bot:"all",
  mapping: {
    c01: {
      name: "Operator Name",
      variable: VarKey.OrgName
    },
    c02: {
      name: "Facility ID",
      variable: VarKey.LocationFMSId
    },
    c03: {
      name: "Tenant ID",
      variable: VarKey.TenantId
    },
    c04: {
      name: "30 days before expiration SMS"
    },
    c05: {
      name: "14 days before expiration SMS"
    },
    c06: {
      name: "7 days before expiration SMS"
    },
    c07: {
      name: "1 day before expiration SMS"
    },
    c08: {
      name: "Day of expiration SMS"
    },
    c09: {
      name: "30 days before expiration Email"
    },
    c10: {
      name: "14 days before expiration Email"
    },
    c11: {
      name: "7 days before expiration Email"
    },
    c12: {
      name: "1 day before expiration Email"
    },
    c13: {
      name: "Day of expiration Email"
    }
  }
};
